/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".error-detail[_ngcontent-%COMP%]{margin:16px 0}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/mobile.iframe.export.pdf.alert.modal/mobile.iframe.export.pdf.alert.modal.component.scss.shim.ngstyle.js.pre-build-optimizer.js